<template>
  <div class="navbar">
    <div class="left-menu">
      <div class="hanburger-container">
        <Hanbuger icon="hamburger-opened"></Hanbuger>        
      </div>
      <Navgater></Navgater>
      <!-- <div class="left-menu-content">互联网医院诊间</div> -->
    </div>
    <div class="right-menu">
      
      <SearchText />
      <!-- <Screenfull></Screenfull> -->
      <Language></Language>
      <!-- 2026-10-13：平台与分店所有启用后台管理账号开放提问，独立于系统维护权限。 -->
      <GptQuestionPanel v-if="canAskQuestions" v-slot="{ openPanel }">
        <a-tooltip title="蓝迪云AI-智能助手">
          <a-button class="question-trigger" type="text" title="蓝迪云AI-智能助手" aria-label="蓝迪云AI-智能助手" @click="openPanel"><template #icon><svg viewBox="0 0 32 32" fill="none" aria-hidden="true" class="ai-chat-icon"><path d="M5 5.5h17a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H13l-6 4v-4H5a3 3 0 0 1-3-3v-13a3 3 0 0 1 3-3Z" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><text x="5.5" y="19.5" fill="currentColor" font-family="Arial,sans-serif" font-size="13" font-weight="700">AI</text><circle cx="26" cy="6" r="5.5" fill="var(--body-background,#fff)"/><text x="23.4" y="9.3" fill="currentColor" font-family="Arial,sans-serif" font-size="11" font-weight="700">?</text></svg></template></a-button>
        </a-tooltip>
      </GptQuestionPanel>
      <c-bridge :count="messageCount" @click="showMessage" style="margin-right: 30px;"></c-bridge>
      <!-- 2026-07-30：顶部新增版本日志入口，点击后展示统一版本信息。 -->
      <a-tooltip title="版本日志">
        <svg-icon class="svgi" icon="histoires" style="width: 24px;margin-right: 10px;" @click="openReleaseLog"></svg-icon>
      </a-tooltip>
      <!-- 2026-09-17：系统维护收进齿轮菜单，当前平台超管且具备有效维护权限才显示。 -->
      <SystemMaintenanceControl v-if="canManageSystemMaintenance" v-slot="{ openPanel }">
        <a-dropdown :trigger="['click']">
          <a-tooltip title="设置">
            <svg-icon class="svgi" icon="setting" style="width: 24px;margin-right: 20px;" tabindex="0" role="button" aria-label="设置"></svg-icon>
          </a-tooltip>
          <template #overlay>
            <a-menu><a-menu-item key="system-maintenance" @click="openPanel">系统维护</a-menu-item></a-menu>
          </template>
        </a-dropdown>
      </SystemMaintenanceControl>
      <svg-icon v-else class="svgi" icon="setting" style="width: 24px;margin-right: 20px;"></svg-icon>
      <a-dropdown>
        <a class="ant-dropdown-link" @click.prevent>
          <img :src="userInfo.avatar" alt="" />
          <span class="user-name-text" :title="userInfo.nickName">{{ userInfo.nickName }}</span>
          <svg-icon icon="cart-down"></svg-icon>
        </a>
        <template #overlay>
          <a-menu>
            <a-menu-item v-if="!userInfo.ghOpenId">
              <div @click="()=>{ghopen.open=true,getQrcode(),getOpenId()}">绑定公众号</div>
            </a-menu-item>
            <a-menu-item>
              <div @click="()=>{open=true}">账号信息</div>
            </a-menu-item>
            <a-menu-item>
              <a href="#" @click="()=>{showPwdEditing=true}">修改密码</a>
            </a-menu-item>
            <a-menu-item>
              <div @click="logout">退出登录</div>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <!-- <svg-icon :icon="iconSetting"></svg-icon> -->
    </div>
    <a-modal v-model:visible="releaseLogVisible" title="版本日志" :footer="null" :width="620">
      <ReleaseLogViewer v-if="releaseLogVisible" :info="releaseInfo" />
    </a-modal>
    <a-modal v-model:visible="showPwdEditing" title="修改密码">
      <a-form ref="formInfo"
      :model="editPwdFormData"
      name="basic"
      :label-col="{style: { width: '110px' }}"
      autocomplete="off"
    >
      <a-form-item label="登录名:" name="loginName">
        <a-input readonly v-model:value="editPwdFormData.loginName"></a-input>
      </a-form-item>
      <a-form-item label="原始密码:" name="password" :help="pwdStatus.passwordHelp" :validate-status="pwdStatus.passwordStatus" :rules="[{ required: true, message: '请录入原始密码!' }]">
        <a-input-password v-model:value="editPwdFormData.password"></a-input-password>
      </a-form-item>
      <a-form-item label="新密码:" name="newPassword" :rules="[{validator: validatePassword,trigger: 'change' }]">
        <a-input-password v-model:value="editPwdFormData.newPassword"></a-input-password>
      </a-form-item>
      <a-form-item label="新密码:" name="confirmPwd" :rules="[{ validator: retryValidatePassword,trigger: 'change' }]">
        <a-input-password v-model:value="editPwdFormData.confirmPwd"></a-input-password>
      </a-form-item>
    </a-form>
    <template #footer>
        <a-button type="primary" @click="updatePwd">确定</a-button><a-button @click="()=>{showPwdEditing=false}">取消</a-button>
      </template>
    </a-modal>
    <a-modal v-model:visible="ghopen.open" :width="300" title="绑定微信公众号">
    <div>         
      <div v-if="!qrcodeUrl"><loading-outlined style="font-size:18px;color:green;" />&nbsp; 正在生成二维码……</div>
      <img v-else style="width:250px" :src="qrcodeUrl" alt="">   
    </div>
    <div style="text-align:center" v-if="ghopen.msg"><svg-icon style="font-size:16px" icon="success"></svg-icon><span>扫码绑定成功</span></div>
    <div style="text-align:center" v-else-if="qrcodeUrl">绑定公众号接收消息提醒</div>
    </a-modal>
    <a-modal v-model:visible="open" title="账号信息">
      <div class="account-details">
        <div class="detail-row"><div>登录账号</div><div>{{userInfo.loginName}}</div></div>
        <div class="detail-row"><div>昵称</div><div>{{userInfo.nickName}}</div></div>
        <div class="detail-row"><div>手机号</div><div>{{userInfo.phone}}</div></div>
        <div class="detail-row"><div>角色</div><div>{{userInfo.roleName}}</div></div>      
        <div class="detail-row"><div>创建时间</div><div>{{dayjs(userInfo.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div></div>
        <div class="detail-row"><div>登录时间</div><div>{{dayjs(userInfo.lastLoginTime).format('YYYY-MM-DD HH:mm:ss')}}</div></div>
        <div class="detail-row"><div>所属机构</div><div>{{userInfo.orgName}}</div></div>
        <div class="detail-row"><div>机构类型</div><div>{{convertOrgType(userInfo.orgType)}}</div></div> 
      </div>
      <template #footer>
        <div  class="client-commands">
          <a-button @click="()=>{open=false}" type="primary">确定</a-button> 
          <a-button @click="()=>{open=false}">取消</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref,computed,onMounted } from 'vue'
import store from '@/store'
import router from '@/router'
import orderRequest from '@/api/orders'
import Screenfull from './Screenfull.vue'
import SearchText from './SearchText.vue'
import {message} from 'ant-design-vue'
import Hanbuger from './Hanbuger.vue'
import { OrgType } from '@/Interfaces/system/audit';
import sysRequest from '@/api/sys'
import Navgater from './Navgater.vue'
import Language from './Language.vue'
import dayjs from 'dayjs'
import CBridge from '@/components/cBirdge/CBridge.vue'
import {LoadingOutlined} from '@ant-design/icons-vue';
import { createDefaultReleaseInfo, normalizeReleaseInfo, ReleaseInfo } from '@/utils/release'
import ReleaseLogViewer from '@/components/ReleaseLogViewer.vue'
import SystemMaintenanceControl from '@/components/maintenance/SystemMaintenanceControl.vue'
import { canManageSystemMaintenance as canMaintain, isPlatformSuperAdministrator } from '@/utils/platformAdministration'
// 2026-10-13：提问面板使用后台会话校验，维护仍沿用平台超级管理员规则。
import GptQuestionPanel from '@/components/questions/GptQuestionPanel.vue'
import { canAskGptQuestions } from '@/utils/gptQuestionAccess'
export default defineComponent({
  setup() {
    const iconSetting = ref<string>('link')
    const formInfo=ref()
    const logout = () => {
      store.dispatch('user/logout')
      router.push('/login')
    }
    const showPwdEditing=ref(false)
    const convertOrgType=(type)=>{
      return OrgType[type] as string
    }
    const showMessage=()=>{
      router.push('/system/messages')
    }
    const releaseLogVisible=ref(false)
    const releaseInfo=ref<ReleaseInfo>(createDefaultReleaseInfo())
    const openReleaseLog=()=>{
      releaseLogVisible.value=true
      sysRequest.getReleaseInfo().then(res=>{
        releaseInfo.value=normalizeReleaseInfo(res.data)
      }).catch(()=>{
        releaseInfo.value=createDefaultReleaseInfo()
      })
    }
    const ghopen=ref({open:false,msg:""})
    const pwdStatus=ref({passwordHelp:'',passwordStatus:''})
    const editPwdFormData=ref({loginName:'',password:'',newPassword:'',confirmPwd:''})
    const open = ref<boolean>(false)
    const userInfo = computed(() => store.state.user.userInfo)
    // 2026-10-18：顶部提问入口与窗口统一读取独立VIP问答开关。
    const canAskQuestions = computed(() => canAskGptQuestions(store.getters.token, store.getters.userInfo, store.getters.sysFunctions))
    const canManageSystemMaintenance = computed(() => canMaintain(store.getters.userInfo,store.getters.functions?.allFunc))
    // 2026-09-17：刷新新增维护权限，避免旧登录缓存隐藏齿轮入口；账号切换后丢弃旧响应。
    const refreshMaintenancePermission=async()=>{
      if(!isPlatformSuperAdministrator(store.getters.userInfo)) return
      const token=store.getters.token,id=store.getters.userInfo.id
      try{
        const response=await sysRequest.getEffectiveFunctions()
        if(store.getters.token===token && store.getters.userInfo.id===id
          && isPlatformSuperAdministrator(store.getters.userInfo) && Array.isArray(response.data)){
          store.commit('user/setFunctions',{...store.getters.functions,allFunc:response.data})
        }
      }catch(_error){ /* 沿用请求层错误提示，后端仍强制校验当前账号。 */ }
    }
    const  validatePassword=(rule, value, callback)=> {
      // 正则表达式，要求密码至少6个字符，至少一个数字，一个小写和一个大写字母  
      const regex = /^(?=.*[0-9])(?=.*[a-zA-Z]).{6,}$/;  
      if (value === '') {  
        callback(new Error('请录入新密码!'));  
      } else if (!regex.test(value)) {  
        callback(new Error('密码必须6位，且包含字母与数字。'));  
      } else {  
        callback();  
      }
    }
    const retryValidatePassword=(rule, value, callback)=>{
      const regex = /^(?=.*[0-9])(?=.*[a-zA-Z]).{6,}$/; 
      if (value === '') {  
        callback(new Error('请再录入一新新密码!'));  
      } else if (!regex.test(value)) {  
        callback(new Error('密码必须6位，且包含字母与数字。'));  
      } else if(editPwdFormData.value.newPassword!=value){  
        callback(new Error('两次密码不一致。'));  
      }else{
        callback();  
      }
    }
    const updatePwd=()=>{
      if(formInfo.value){
        formInfo.value.validate().then(res=>{
          sysRequest.upateOperatorPwd({...res,id:store.getters.userInfo.id}).then(res=>{
            if(res.data>0){
              message.success('密码修改成功')
              pwdStatus.value.passwordStatus=''
              pwdStatus.value.passwordHelp=""
            }else{
              pwdStatus.value.passwordStatus='error'
              pwdStatus.value.passwordHelp="原始密码不正确"
              message.error('密码修改失败,原始密码不正确')
            }
          })
        })
      }
    }

    const qrcodeUrl=ref('')
    const getQrcode=()=>{
      sysRequest.getQrcode(store.getters.userInfo.id).then(res=>{
        qrcodeUrl.value=res.data.qrCodeUrl
      })
    }
    const messageCount=ref(0)
    const getCountOfmessages=()=>{
      orderRequest.getCountOfmessages().then(res=>{
        messageCount.value=res.data
      })
    }
    const timeint=ref()
    const getOpenId=()=>{
      timeint.value= window.setInterval(()=>{
        sysRequest.getGhopenId(userInfo.value.id).then(res=>{
          if(res.data){
            store.state.user.userInfo.ghOpenId=res.data
            store.commit('user/setUserInfo', store.state.user.userInfo)
            ghopen.value.msg="扫码绑定成功"
            window.clearInterval(timeint.value)
            window.setTimeout(()=>{
              ghopen.value.open=false
            },1000)
          }          
        })
        if(!ghopen.value.open){
          window.clearInterval(timeint.value)
        }
      },2000)      
    }
    onMounted(()=>{
      void refreshMaintenancePermission()
      if(router.currentRoute.value.query.type && router.currentRoute.value.query.type=='1'){
        showPwdEditing.value=true
        message.success("您的账号密码过于简单，请修改登录密码。")
      }
      store.state.app.clearMessageCount=()=>{
        messageCount.value=0
      }
      getCountOfmessages()
      editPwdFormData.value.loginName=userInfo.value.loginName
      
      // store.state.app.onsysmessage=(msg)=>{
      //   const val=JSON.parse(msg.data.replace(/'/g, '"'))
        
      //   if(val.type=="WxBinding"){
      //     store.state.user.userInfo.ghOpenId=val.openId
      //     store.commit('user/setUserInfo', store.state.user.userInfo)
      //     ghopen.value.msg="扫码绑定成功"
      //     window.setTimeout(()=>{
      //       ghopen.value.open=false
      //     },1000)
      //   }
      // }
      
    })
    return {
      iconSetting, logout,userInfo,open,dayjs,convertOrgType,showPwdEditing,updatePwd,editPwdFormData,formInfo,
      retryValidatePassword,validatePassword,pwdStatus,ghopen,qrcodeUrl,getQrcode,showMessage,messageCount,getOpenId,
      releaseLogVisible,releaseInfo,openReleaseLog,canManageSystemMaintenance,canAskQuestions
    }
  },
  components: {SearchText,
    Hanbuger, Navgater, CBridge,Language,LoadingOutlined,SystemMaintenanceControl,GptQuestionPanel,ReleaseLogViewer
  }
})

</script>
<style lang="scss" scoped>
.navbar {
  // display: block;
  // 2026-09-22：功能用途允许换行，顶部随内容增高，保留账号与维护等右侧入口。
  min-height: 70px;
  height: auto;
  padding: 8px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;

  .hanburger-container {
    // float: left;
    margin: 0 10px;
  }

  .left-menu {
    min-width: 0;
    flex: 1 1 0;
    height: auto;
    display: flex;
    align-items: center;

    .left-menu-content {
      font-size: 18px;
      font-weight: 600;
      margin-left: 12px;
    }
  }

  .right-menu {
    // float: right;
    height: 100%;
    display: flex;
    display: flex;
    align-items: center;
    // gap: 5px;
    margin: 0 20px;

    .ant-dropdown-link {
      color: #666666;
      font-size: 14px;
      img {
        width: 30px;
        height:30px;
        border-radius: 30px;
      }
    }
    .user-name-text{
      margin: 0 10px;
    }
    .svgi {
      width: 35px;
      height: 35px;
      padding:5px;
      cursor: pointer;
      transition: background 0.5s;
      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
// 2026-10-01：只放大顶部五个功能图标，覆盖子组件24px内联宽度；头像和下拉箭头保持原尺寸。
.navbar .right-menu :deep(.svgi) {
  width:36px !important; height:36px; padding:4px; box-sizing:border-box;
  margin-right:8px !important; flex-shrink:0;
}
.navbar .right-menu :deep(.bridge-container) { margin-right:8px !important; flex-shrink:0; }
.navbar .right-menu :deep(.bridge-container .svgi) { margin-right:0 !important; }
// 2026-10-13：提问图标采用与既有工具一致的固定尺寸，避免窄屏布局移动。
.navbar .right-menu .question-trigger { display:inline-flex; align-items:center; justify-content:center; box-sizing:border-box; width:40px; height:40px; padding:2px; margin-right:8px; flex-shrink:0; font-size:36px; line-height:1; color:inherit; }
.navbar .right-menu .question-trigger :deep(.anticon) { display:inline-flex; align-items:center; justify-content:center; font-size:28px; line-height:1; }
.navbar .right-menu .question-trigger :deep(svg) { display:block; width:36px; height:36px; }
// 2026-09-22：小窗口将工具栏放在下一行，功能说明和所有工具都保持可见。
@media(max-width:1100px) {
  .navbar { flex-wrap:wrap; gap:8px 0; }
  #app .main-container .navbar .left-menu { flex-basis:100%; padding-right:12px; }
  #app .main-container .navbar .right-menu { margin-left:auto; }
}

.account-details{
    font-size:16px;
    .detail-row{
      display:flex;
      height:35px;
      line-height:35px;
      div:first-child{
        width:100px;
        font-weight: bold;
        margin-right:10px;
        text-align: right;
      }
    }
    .command-row{
      
      margin:10px auto;
      width:200px;
      display:flex;
      gap:10px;
      justify-content: space-around;
    }

    
  }
/* 顶部工具统一间距，保留原图标及AI点击区尺寸。 */
.navbar .right-menu { gap:6px; margin:0 12px; flex:none; }
.navbar .right-menu :deep(.svgi),
.navbar .right-menu :deep(.bridge-container),
.navbar .right-menu .question-trigger { margin-right:0 !important; }
.navbar .right-menu .ant-dropdown-link { display:inline-flex; align-items:center; min-width:0; gap:6px; }
.navbar .right-menu .user-name-text { max-width:120px; margin:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.navbar .right-menu .svgi,.navbar .right-menu .question-trigger { border-radius:6px; }
.navbar .right-menu .svgi:hover,.navbar .right-menu .question-trigger:hover { background:var(--admin-skin-soft,#edf3f9); color:var(--activeColor,#1890ff); }
</style>
